
import Icon from "@/Components/Icon/Icon";
import { getDelayData } from "@/Helpers/DashboardHelper";
import { getYMDFromDate } from "@/Helpers/DateFunctions";
import { useProgrammation } from "@/Hooks/UseProgrammation";
import { useProject } from "@/Hooks/UseProject";
import useTranslation from "@/Hooks/UseTranslation";
import { setDashboardDelayDataAction } from "@/Redux/Actions/DashboardActions";
import React, { useEffect, useMemo } from "react";
import { Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

const OverdueTasks = () => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { programmationLoaded } = useProgrammation()

  const { project } = useProject()

  const dashboard = useSelector((state: any) => state.DashboardReducer)
  const programmation = useSelector((state: any) => state.ProgrammationReducer)

  const nonWorkingDays = useMemo(() => {

    return project.nonWorkingDays.map((day: string) => {

      const date = new Date(day)

      return getYMDFromDate(date)
    })
  }, [ project.nonWorkingDays ])

  const getDelayedTasksColorClass = () => {

    if (dashboard.delayData.tasks === 0)
      return 'text-color-completada'

    return 'text-color-atrasada'
  }

  useEffect(() => {

    const loadDelayData = () => {

      const { delayedTasks, estimatedTotalDelay } = getDelayData(programmation.tasks, nonWorkingDays)

      const delayData = {
        tasks: delayedTasks,
        estimatedTotal: estimatedTotalDelay
      }

      dispatch(setDashboardDelayDataAction(delayData))
    }

    if (programmationLoaded) {

      if (dashboard.loadDelayStatus !== 'loading') {

        loadDelayData()
      }
    }
  }, [ programmationLoaded, dashboard.loadDelayStatus ])

  return (
    <Card className="card-icon-bg card-icon-bg-primary o-hidden mb-4">
      <Card.Body className="text-center">
        <Icon name={`estado_atrasada ${getDelayedTasksColorClass()}`}
          style={{ fontSize: '4rem' }}
        />
        <div className="content ml-3" style={{ maxWidth: 'none' }}>
          <p className="text-muted mt-2 mb-0">
            {t('DASHBOARD:SummaryOverdueTasks')}
          </p>
          <p className={`${getDelayedTasksColorClass()} text-30 line-height-1 mb-2`}>
            {dashboard.delayData.tasks}
          </p>
        </div>
      </Card.Body>
    </Card>
  )
}

export default OverdueTasks;
